import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { CodecraftQuizInstance } from '@codecraft-works/data-models';
import { jwtDecode } from 'jwt-decode';
import { Observable, of } from 'rxjs';
import { QuizService } from '../data-access/quiz.service';
import { CodecraftQuizTableViewComponent } from '../ui/quiz-table-view.component';

@Component({
  standalone: true,
  selector: 'codecraft-quiz-list-page',
  template: `
    <codecraft-quiz-table-view
      *ngIf="quizResults$"
      [quizData$]="quizResults$"
    />
  `,
  styles: [],
  imports: [CodecraftQuizTableViewComponent, NgIf],
})
export class CodecraftQuizListPageComponent implements OnInit {
  @Input() uid!: string;
  quizResults$: Observable<CodecraftQuizInstance[]>;
  constructor(private quizService: QuizService) {}

  async ngOnInit(): Promise<void> {
    // Get token from cookie named `session`
    const idToken = document.cookie
      ?.split('; ')
      ?.find((row) => row.startsWith('session='))
      ?.split('=')[1];

    if (idToken) {
      try {
        const decoded: any = jwtDecode(idToken);
        this.uid = decoded.user_id || decoded.uid;
      } catch (e) {
        this.quizService.setQuizState({
          component: 'error',
          error: 'Invalid JWT token',
        });
        return;
      }
    }
    try {
      this.quizResults$ = of(
        await this.quizService.getAllQuizResults(this.uid)
      );
    } catch (error) {
      console.error(error);
    }
  }
}
